import { useOutletContext } from "react-router-dom";
import { useCmsContent, useSimilarToContent } from "../../../features/content/hooks";
import styles from "../seriesListingWidget/seriesListingWidget.module.scss";
import { FormattedMessage } from "react-intl";
import ListingHeader from "../../../components/listingHeader/listingHeader";
import RefCardsCarousel from "../../../components/refCardsCarousel/refCardsCarousel";
import AnimeSeriesCard from "../../../components/animeSeriesCard/animeSeriesCard";
import StreamCard from "../../../components/streamCard/streamCard";
import { useStoryblokGlobalSettings } from "../../../hooks/useStoryblokGlobalSettings";
import useMediaQuery from "../../../hooks/useMediaQuery";
import { useCompressedImage } from "../../../components/storyblokImageBasic/helpers";

const useRecommendedContent = (guid) => {
  const { data: cmsContent, isLoading: isLoadingCmsContent, isError } = useCmsContent(guid);
  const { data: similarToContent, isLoading: isLoadingSimilarTo } = useSimilarToContent(guid, 2)

  return {
    isLoading: isLoadingCmsContent || isLoadingSimilarTo,
    data: [
      ...(cmsContent ? [cmsContent] : []),
      ...(similarToContent || []),
    ],
    isError,
  }
}

export const ArticleCmsRecommendedStreaming = () => {
  const { story } = useOutletContext();
  const globalSettings = useStoryblokGlobalSettings();
  const isMobile = useMediaQuery("(max-width: 992px)");
  const backgroundImageURI = useCompressedImage(globalSettings?.carousel_background_image?.filename);

  if (!story) {
    return null
  }

  const { content: { crcms_guid } } = story;

  if (!crcms_guid) {
    return null;
  }

  const { data, isLoading, isError } = useRecommendedContent(crcms_guid);

  if (isError) {
    return null;
  }

  return (
    <section className={styles.seriesListingWidget}>
      <div
        className={styles.carousel}
        style={
          isMobile
            ? {
              backgroundImage: `url(${backgroundImageURI}), linear-gradient(305.82deg, #213944 11.54%, #2ABDBB 95.62%)`,
            }
            : null
        }
      >
        {isMobile ? (
          <div className={styles.header}>
            <h3>
              <FormattedMessage id="component.series_listing_widget.headline" />
            </h3>
          </div>
        ) : (
          <ListingHeader>
            <h3>
              <FormattedMessage id="component.series_listing_widget.headline" />
            </h3>
          </ListingHeader>
        )}
        {isLoading ? <div className="loader centered" /> : null}
        {isMobile ? (
          // MOBILE CAROUSEL
          <div className={styles.mobilecarousel}>
            <RefCardsCarousel
              desktopOptions={{ perPage: 3 }}
              tabletOptions={{ perPage: 3 }}
              smallTabletOptions={{ perPage: 3 }}
              mobileExtendedOptions={{ perPage: 3, gap: 10 }}
              mobileOptions={{ perPage: 2, gap: 10 }}
              extraSmallOptions={{ perPage: 1, gap: 10 }}
            >
              {data.map((content) => (
                <AnimeSeriesCard key={content.id} series={{
                  crcms_title: content.title,
                  imageSrc: content.posterWideImage,
                  series_url: content.link,
                }} />
              ))}
            </RefCardsCarousel>
          </div>
        ) : (
          // DESKTOP LAYOUT
          <ul className={styles.wrapper}>
            {data.map((content) => (
              <li key={content.id}>
                <StreamCard
                  image={content.posterWideImage}
                  title={content.title}
                  buttonLink={content.link}
                />
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
